import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const constantRouter = [{
		path: '/login',
		name: "登录",
		component: () => import('@/pages/login.vue')
	},
	{
		path: '/404',
		name: "404",
		component: () => import('@/pages/404.vue')
	},
	{
		path: '/',
		name: "layout",
		meta: {
			auth: true
		},
		component: () => import('@/layout/index.vue'),
		children: [{
				path: '/',
				meta: {
					auth: true
				},
				component: () => import('@/pages/index/statistics.vue')
			},
			{
				path: '/wechat-mini',
				meta: {
					auth: true
				},
				component: () => import("@/pages/site-set/wechat-mini.vue")
			},
			{
				path: '/upload-set',
				meta: {
					auth: true
				},
				component: () => import("@/pages/site-set/upload-set.vue")
			}, {
				path: '/pay-set',
				meta: {
					auth: true
				},
				component: () => import("@/pages/site-set/pay-set.vue")
			}, {
				path: '/user-list',
				meta: {
					auth: true
				},
				component: () => import("@/pages/user/user-list.vue")
			}, {
				path: '/user-role',
				meta: {
					auth: true
				},
				component: () => import("@/pages/user/user-role.vue")
			},
			{
				path: '/send-message',
				meta: {
					auth: true
				},
				component: () => import("@/pages/user/send-message.vue")
			},
			{
				path: '/admin-list',
				meta: {
					auth: true
				},
				component: () => import("@/pages/user/admin-list.vue")
			},
			{
				path: '/topic-list',
				meta: {
					auth: true
				},
				component: () => import("@/pages/content/topic-list.vue")
			},
			{
				path: '/comment-list',
				meta: {
					auth: true
				},
				component: () => import("@/pages/content/comment-list.vue")
			},
			{
				path: '/post-list',
				meta: {
					auth: true
				},
				component: () => import("@/pages/content/post-list.vue")
			},
			{
				path: '/discuss-list',
				meta: {
					auth: true
				},
				component: () => import("@/pages/content/discuss-list.vue")
			},
			{
				path: '/topic-class',
				meta: {
					auth: true
				},
				component: () => import("@/pages/content/topic-class.vue")
			},
			{
				path: '/article-add',
				meta: {
					auth: true
				},
				component: () => import("@/pages/content/article-add.vue")
			},
			{
				path: '/article-list',
				meta: {
					auth: true
				},
				component: () => import("@/pages/content/article-list.vue")
			},
			{
				path: '/order-list',
				meta: {
					auth: true
				},
				component: () => import("@/pages/shop/order-list.vue")
			},
			{
				path: '/goods-list',
				meta: {
					auth: true
				},
				component: () => import("@/pages/shop/goods-list.vue")
			},
			{
				path: '/goods-add',
				meta: {
					auth: true
				},
				component: () => import("@/pages/shop/goods-add.vue")
			},
			{
				path: '/swiper-list',
				meta: {
					auth: true
				},
				component: () => import("@/pages/shop/swiper-list.vue")
			},
			{
				path: '/nav-list',
				meta: {
					auth: true
				},
				component: () => import("@/pages/shop/nav-list.vue")
			},
			{
				path: '/site-swiper',
				meta: {
					auth: true
				},
				component: () => import("@/pages/site-set/swiper-list.vue")
			},
			{
				path: '/vest-list',
				meta: {
					auth: true
				},
				component: () => import("@/pages/operate/vest/list.vue")
			},
			{
				path: '/vest-post-add',
				meta: {
					auth: true
				},
				component: () => import("@/pages/operate/vest/post-add.vue")
			},
			{
				path: '/vest-post-agree',
				meta: {
					auth: true
				},
				component: () => import("@/pages/operate/vest/post-agree.vue")
			},
			{
				path: '/vest-post-comment',
				meta: {
					auth: true
				},
				component: () => import("@/pages/operate/vest/post-comment.vue")
			},
			{
				path: '/vest-user-follow',
				meta: {
					auth: true
				},
				component: () => import("@/pages/operate/vest/user-follow.vue")
			}
		]
	}
]

export default new Router({
	routes: constantRouter,
	// mode: 'history'
});
